(ns hai.spaces.routes
  (:require
   [hai.spaces.detail :as detail]
   [hai.spaces.table :as table]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as-alias routing]))

(defn routes []
  [["/spaces"
    {:label "Spaces"
     :icon (icons/mui-icon :outlined :workspaces)}
    [""
     {:name :spaces/view
      :view table/page}]
    ["/{space/uuid}"
     {:name :spaces/detail
      :breadcrumbs [:spaces/view "Space"]
      :view detail/page
      :controllers [{:parameters {:path [:space/uuid]}
                     :start (fn [{path :path}]
                              (>e [:entity/resolve path
                                   {:on-success-fx [[:dispatch [::detail/mark-resolved (:space/uuid path)]]]
                                    :on-error-fx   [[:dispatch [::detail/mark-resolved (:space/uuid path)]]]}]))}]}]]])
